export const zIndex = {
  NEGATIVE_ONE: -1,
  DEFAULT: 0,
  ONE: 1,
  TWO: 2,
  MEGA_MENU: 100,
  STRIPE: 200,
  HEADER_LOGO: 200,
  PRODUCT_LIST: 300,
  DATE_PICKER: 500,
  GLOBAL_NOTIFICATION: 700,
  MODAL_OVERLAY: 900,
  MODAL_CONTENTS: 1000,
  DIALOG: 1050,
  POPOVER: 1100,
  SNACKBAR: 1200,
  TOP: 1500
};